export default __webpack_public_path__ + "static/media/gates_logo.80d50886.png";